import React from 'react';

import { Label } from '@atlas/ui';

import ConfirmPopup from 'common/Popup/ConfirmPopup';

const BonusBoostPopup = ({ bonusBoost, onClose }) => {
  const bonusBoostItems = bonusBoost?.items?.map(item => {
    if (item.amount) {
      return (
        <div className="bonus-boost_outcome popup__text">
          <span>
            +{(item.amount * 100 - 100).toFixed(0)}
            <span className="bonus-boost_outcome_percent">%</span>
          </span>
          <span>
            ({item.position}
            <Label
              className="bonus-boost_outcome_condition"
              message="bonus_boost_popup_conditions"
            />
            )
          </span>
        </div>
      );
    }
    return null;
  });

  return (
    <ConfirmPopup
      data={{
        className: 'bonus-boost-popup',
        closeLabel: 'bonus_boost_popup_ok_button',
        onConfirm: onClose,
        secondaryBtn: false,
      }}
      message="bonus_boost_popup_message"
      title="bonus_boost_popup_title"
    >
      <div className="bonus-boost_outcomes">{bonusBoostItems}</div>
      <Label className="popup__text" message="bonus_boost_popup_wish" />
    </ConfirmPopup>
  );
};

export default BonusBoostPopup;
